/**
 * Incident Root Cause Service – QMS Phase 2
 * CRUD for incident_root_causes (linked to incident + optional failed control).
 */

import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  Timestamp
} from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'incident_root_causes';

export class IncidentRootCauseService {
  constructor() {
    this.collectionRef = collection(db, COLLECTION);
  }

  async create(data, userId) {
    const now = Timestamp.now();
    const payload = {
      incidentReportId: data.incidentReportId,
      failedControlId: data.failedControlId || null,
      rootCauseText: data.rootCauseText || '',
      contributingFactors: data.contributingFactors || '',
      correctiveActions: data.correctiveActions || '',
      preventiveActions: data.preventiveActions || '',
      status: data.status || 'Planned',
      dueDate: data.dueDate ? Timestamp.fromDate(new Date(data.dueDate)) : null,
      protocolId: data.protocolId || null,
      protocolName: data.protocolName || null,
      createdAt: now,
      createdBy: userId,
      updatedAt: now,
      updatedBy: userId
    };
    const ref = await addDoc(this.collectionRef, payload);
    return ref.id;
  }

  async get(id) {
    const ref = doc(this.collectionRef, id);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    return { id: snap.id, ...snap.data() };
  }

  async getByIncidentId(incidentReportId) {
    if (!incidentReportId) return [];
    const q = query(
      this.collectionRef,
      where('incidentReportId', '==', incidentReportId),
      orderBy('createdAt', 'desc')
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  }

  async update(id, updates, userId) {
    const ref = doc(this.collectionRef, id);
    const patch = { ...updates, updatedAt: Timestamp.now(), updatedBy: userId };
    if (updates.dueDate !== undefined) patch.dueDate = updates.dueDate ? Timestamp.fromDate(new Date(updates.dueDate)) : null;
    await updateDoc(ref, patch);
  }

  async delete(id) {
    const ref = doc(this.collectionRef, id);
    await deleteDoc(ref);
  }
}

export const incidentRootCauseService = new IncidentRootCauseService();
